import { render, staticRenderFns } from "./DeviceRelocationDialog.vue?vue&type=template&id=203e6060&scoped=true&"
import script from "./DeviceRelocationDialog.vue?vue&type=script&lang=js&"
export * from "./DeviceRelocationDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRelocationDialog.vue?vue&type=style&index=0&id=203e6060&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203e6060",
  null
  
)

/* custom blocks */
import block0 from "./DeviceRelocationDialog.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203e6060')) {
      api.createRecord('203e6060', component.options)
    } else {
      api.reload('203e6060', component.options)
    }
    module.hot.accept("./DeviceRelocationDialog.vue?vue&type=template&id=203e6060&scoped=true&", function () {
      api.rerender('203e6060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Sensor/DeviceRelocationDialog.vue"
export default component.exports